import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactPlayer from "react-player";
import ToolButton from "./toolComponents/ToolButton.jsx";
import IconButton from "./toolComponents/IconButton.jsx";
import WsComponent from "./toolComponents/WsComponent.jsx";
import SelectCanvas from "./toolComponents/mode_components/SelectCanvas.jsx";
import DrawCanvas from "./toolComponents/mode_components/DrawCanvas.jsx";
import TextBoxCanvas from "./toolComponents/mode_components/TextBoxCanvas.jsx";
import TimeAssignCanvas from "./toolComponents/mode_components/TimeAssignCanvas.jsx";
import CoachCanvas from "./toolComponents/mode_components/CoachCanvas.jsx";
import PopupCanvas from "./toolComponents/mode_components/PopupCanvas.jsx";
import ReadCanvas from "./toolComponents/mode_components/ReadCanvas.jsx";
import ColorPopup from "./toolComponents/ColorPopup";
import UploadQuizImage from "./UploadQuizImage";
import {
  displaySuccessToast,
  displayErrorToast,
} from "../../../utils/toast.js";
import { BsFiletypeJson } from "react-icons/bs";

// react-icons
import { FaMousePointer } from "react-icons/fa";
import { BsBoxArrowDownRight } from "react-icons/bs";
import { RiMapPinTimeLine, RiSave3Fill } from "react-icons/ri";
import {
  MdLiveHelp,
  MdDelete,
  MdOutlinePictureInPicture,
} from "react-icons/md";
import { IoColorPaletteOutline } from "react-icons/io5";

import CustomYesNoModal from "../../micro_components/CustomYesNoModal.jsx";
import "../../styles/developToolStyles.css";
import ChapterDataService from "../../../services/ChapterService.js";

import { ReactComponent as RepeatSymbol } from "./assets/Repeatsign.svg";
import HeresAmericaService from "../../../services/HA/HeresAmericaService.js";
import RepeatPopup from "./toolComponents/RepeatPopup.jsx";

// BUG: when the (wavesurfer) player has reached the end and is paused, bringing up
// the 'clear canvas' modal will cause the player to play agin from the beginning

// TODO: add a (toggleable) legend for each canvas that shows some of the
// more abstract symbolism (red line for pauseAfter, visual for repeats, etc.)
// maybe turn this into a collapsable help page

// TODO: when entering read mode, re-order all the rects by start time

// TODO: change the fill of all rects when the color picker is visible, so the user can preview what it will look like

// BIG TODO: change all rects to a single component so they all have their own state

function DevelopTool({
  passedPage,
  pageId,
  videoLink,
  preview,
  setPreview,
  jsonData,
  reloadPages,
  setLoadingUpload,
  setUploadingModalOpen,
  setCurrentPageJson,
  currentChapter,
  bookId,
  isHeresAmericaDomain,
  chapterAndPageInfo,
}) {
  const [chapterType, setChapterType] = useState("video");
  const containerRef = useRef();
  const [showJsonEditor, setShowJsonEditor] = useState(false);

  const image = new window.Image();
  const [isPlaying, setIsPlaying] = useState(false);
  const [playTime, setPlayTime] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [currentTool, setCurrentTool] = useState("select");
  const [background, setBackground] = useState();
  const [canvasWidth, setCanvasWidth] = useState(792);
  const [canvasHeight, setCanvasHeight] = useState(1024);
  const [currentAspect, setCurrentAspect] = useState(1);
  const aspectRef = useRef(currentAspect);
  const [canvasScale, setCanvasScale] = useState(1);
  const stageRef = useRef();
  const bgRef = useRef();
  const [rects, setRects] = useState(
    jsonData ? (jsonData.rects ? jsonData.rects : []) : []
  );
  const [points, setPoints] = useState(
    jsonData ? (jsonData.points ? jsonData.points : []) : []
  );
  const [popupTriggers, setPopupTriggers] = useState(
    jsonData?.popupTriggers || []
  );
  const [hasHaQuizBeenDeleted, setHasHaQuizBeenDeleted] = useState(false);
  const [fill, setFill] = useState("rgb(255, 255, 0)");
  const [pointColor, setPointColor] = useState("#54add8");
  const [opacity, setOpacity] = useState(0.3);
  const [isClearModalOpen, setIsClearModalOpen] = useState(false);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const wavesurferRef = useRef();
  const videoRef = useRef();
  const minScale = 15;
  const [colorPickerVisible, setColorPickerVisible] = useState(false);
  const colorButtonRef = useRef();

  const [pickerColor, setPickerColor] = useState({
    r: 255,
    g: 255,
    b: 0,
    a: 0.3,
  });
  const [activeRect, setActiveRect] = useState({});
  const [willPause, setWillPause] = useState(false);
  const [repeatPopup, setRepeatPopup] = useState(false);
  const repeatButtonRef = useRef();
  const [iterations, setIterations] = useState([]); // for baked-in repeats
  const [workingIteration, setWorkingIteration] = useState(-1);

  // detect OS
  let OS;
  if (navigator.userAgent.indexOf("Mac OS X") !== -1) {
    OS = "mac";
  } else {
    OS = "windows";
  }

  useEffect(() => {
    setRects(jsonData?.rects || []);
    setPoints(jsonData?.points || []);
    const updatedPopupTriggers = (jsonData?.popupTriggers || []).map(
      (trigger) => {
        return { ...trigger };
      }
    );
    setPopupTriggers(updatedPopupTriggers);
    console.log("🚀 ~ file: DevelopTool.jsx:115 ~ jsonData:", jsonData);
  }, [jsonData]);
  useEffect(() => {
    console.log(
      "🚀 ~ file: DevelopTool.jsx:119 ~ useEffect ~ popupTriggers:",
      popupTriggers
    );
  }, [popupTriggers]);

  useEffect(() => {
    if (
      jsonData &&
      jsonData.rects &&
      jsonData.rects[0] &&
      jsonData.rects[0].fill
    ) {
      setFill(jsonData.rects[0].fill);
    }
  }, [jsonData, jsonData && jsonData.length, jsonData && jsonData.rects]);

  useEffect(() => {
    aspectRef.current = currentAspect;
  }, [currentAspect]);

  const changePickerColor = (color) => {
    setPickerColor(color.rgb);
  };

  // get information regarding the chapter media when the user changes chapters
  useEffect(() => {
    setChapterType(videoLink ? "video" : "audio");
    if (currentChapter.videoLink) setChapterType("video");
    else if (currentChapter.audioLink) setChapterType("audio");
    else setChapterType("neither");
  }, [currentChapter]);

  // based on the 'listening' state we can control exactly when the hotkeys are handled
  const [listening, setListening] = useState(true);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    if (listening) window.addEventListener("keydown", handleKeyDown);
    else window.removeEventListener("keydown", handleKeyDown);
    window.addEventListener("contextmenu", handleContext);
    // window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("contextmenu", handleContext);
    };
  }, [listening]);

  // const handleClick = useCallback((e) => {
  //   console.log(e.target.getBoundingClientRect());
  // }, []);
  useEffect(() => {
    if (showJsonEditor) {
      setListening(false);
    } else {
      setListening(true);
    }
  }, [showJsonEditor]);
  const handleWindowResize = useCallback(() => {
    setCanvasWidth(containerRef.current.clientWidth);
    setCanvasHeight(containerRef.current.clientWidth / aspectRef.current);
    setCanvasScale(containerRef.current.clientWidth / 792);
  }, []);

  const handleContext = useCallback((e) => {
    e.preventDefault();
  }, []);

  // hotkeys
  const handleKeyDown = useCallback(
    (e) => {
      const { metaKey, ctrlKey } = e;

      switch (e.key) {
        case "e": {
          // put debug console.logs here
          console.log(points);
          break;
        }
        case "`": {
          setPlaybackRate(0.25);
          break;
        }
        case "1": {
          setPlaybackRate(0.5);
          break;
        }

        case "2": {
          setPlaybackRate(0.75);
          break;
        }

        case "3": {
          setPlaybackRate(1);
          break;
        }
        case "s": {
          if (metaKey || ctrlKey) {
            e.preventDefault();
            setIsSaveModalOpen(true);
          } else {
            if (!preview) setCurrentTool("select");
          }
          break;
        }
        case "r": {
          if (metaKey || ctrlKey) {
            break;
          }
          setRepeatPopup(false);
          setPreview((p) => !p);
          break;
        }
        case "d": {
          if (!preview) setCurrentTool("draw");
          break;
        }
        case "t": {
          if (!preview) setCurrentTool("time assign");
          break;
        }
        case "c": {
          if (!preview) setCurrentTool("coach");
          break;
        }
        case "q": {
          if (!preview) setCurrentTool("popup");
          break;
        }
        case "k":
        case " ": {
          e.preventDefault();
          setIsPlaying((p) => !p);
          break;
        }
        default:
          break;
      }
    },
    [preview]
  );

  useEffect(() => {
    setListening(!repeatPopup);
  }, [repeatPopup]);

  // split the result from the color picker into RGB and alpha
  useEffect(() => {
    setFill(`rgb(${pickerColor.r}, ${pickerColor.g}, ${pickerColor.b})`);
    setOpacity(pickerColor.a);
    // console.log(pickerColor);
  }, [pickerColor]);

  useEffect(() => {
    deselectAll();
  }, [currentTool]);

  // set background image
  useEffect(() => {
    // loadJsonFromBackend(); //need to add confirmation or something instead of this
    image.src = passedPage;
    // we need only set the width of the image here,
    // since the canvas itself is responsive to the window width
    image.onload = () => {
      let scaleFactor = canvasWidth / image.width;
      setCurrentAspect(image.width / image.height);
      image.width = (scaleFactor * image.width) / canvasScale;
      image.height = (scaleFactor * image.height) / canvasScale;
      setCanvasHeight(image.height * canvasScale);

      setBackground(image);
    };
  }, [passedPage]);

  // this useEffect is for forcing the canvas to take to the initial dimensions when the app is first loaded
  useEffect(() => {
    handleWindowResize();
  }, [background]);

  // useEffect(() => {
  //   console.log("print json: ", printJson);
  // }, [printJson]);

  const deselectAll = () => {
    if (rects) {
      setRects(
        rects.map((rect) => {
          return {
            ...rect,
            selected: false,
          };
        })
      );
    }
  };

  const updatePointCoords = (movedID, { x, y }) => {
    setPoints(
      points.map((point) => {
        if (point.id === movedID) {
          return { ...point, x: x, y: y };
        } else return point;
      })
    );
  };

  const updatePopupTriggerCoords = (movedID, { x, y }) => {
    setPopupTriggers(
      popupTriggers.map((trigger) => {
        if (trigger.id === movedID) {
          return { ...trigger, x: x, y: y };
        } else return trigger;
      })
    );
  };

  const clearCanvas = () => {
    setRects([]);
    setPoints([]);
    setIsClearModalOpen(false);
  };

  // get current time in seconds for assigning to rects
  const getTime = () => {
    if (chapterType === "audio")
      return wavesurferRef.current.getCurrentTime().toFixed(3);
    else if (chapterType === "video")
      return videoRef.current.getCurrentTime().toFixed(3);
  };

  // seek to specified time when clicking on rects in read mode
  const seek = (time) => {
    if (chapterType === "audio") {
      wavesurferRef.current.seekTo(time / wavesurferRef.current.getDuration());
      setIsPlaying(true);
    } else if (chapterType === "video") {
      videoRef.current.seekTo(time, "seconds");
      if (!isPlaying) setIsPlaying(true);

      let findRect =
        videoRef.current.getCurrentTime() >= rects[rects.length - 1].startTime
          ? rects[rects.length - 1]
          : rects[
              rects.find((r) => r.startTime > videoRef.current.getCurrentTime())
                .id - 1
            ];
      setActiveRect(findRect);
    }
  };

  // need to use this separate function instead of passing
  // a prop into the other seek function for preventing
  // play after seek, because apparently that doesn't work??
  const seekFrame = (time) => {
    if (chapterType === "audio") wavesurferRef.current.setCurrentTime();
    else if (chapterType === "video") {
      videoRef.current.seekTo(time, "seconds");
      setIsPlaying(false);
    }
  };

  // JSON compiler
  const handleSaveButton = async (event) => {
    event?.preventDefault();
    let jsonOut = [],
      rectsOut = [],
      pointsOut = [],
      triggersOut = [];

    for (let i = 0; i < rects.length; i++) {
      rectsOut.push({
        id: i,
        x: Math.round(rects[i].x),
        y: Math.round(rects[i].y),
        width: Math.round(rects[i].width),
        height: Math.round(rects[i].height),
        fill: fill,
        opacity: opacity,
        startTime: rects[i].startTime,
        pauseAfter: rects[i].pauseAfter,
      });
    }

    if (points && points.length > 0) {
      for (let i = 0; i < points.length; i++) {
        let tempTitles = points[i].title;
        if (tempTitles && tempTitles.length > 0) {
          // clean up any undefined keys
          Object.keys(tempTitles).forEach(
            (key) => tempTitles[key] === undefined && delete tempTitles[key]
          );
        }
        let tempLinks = points[i].link;
        if (tempLinks && tempLinks.length > 0) {
          // clean up any undefined keys
          Object.keys(tempLinks).forEach(
            (key) => tempLinks[key] === undefined && delete tempLinks[key]
          );
        }
        pointsOut.push({
          id: i,
          x: Math.round(points[i].x),
          y: Math.round(points[i].y),
          scale: points[i].scale,
          color: points[i].color,
          title: tempTitles,
          link: tempLinks,
          iconUrl: points[i].iconUrl,
          direction: points[i].direction,
          audioTracks: points[i].audioTracks,
          subtitles: points[i].subtitles,
        });
      }
    }
    console.log("popupTriggers in handlesavebutton before ", popupTriggers);
    if (popupTriggers && popupTriggers.length > 0) {
      popupTriggers.forEach(
        ({
          id,
          x,
          y,
          width,
          height,
          title,
          titleAudio,
          iconUrl,
          scale,
          items,
          type,
          isQuiz,
          quizDetails,
          haQuizId,
          languageSelectionMenu,
          onPageShortAnswerDetails,
        }) => {
          triggersOut.push({
            id,
            x: Math.round(x),
            y: Math.round(y),
            ...(width && { width: Math.round(width) }),
            ...(height && { height: Math.round(height) }),
            ...(title && { title }),
            ...(titleAudio && { titleAudio }),
            ...(iconUrl && { iconUrl }),
            ...(scale && { scale }),
            items,
            type,
            ...(isQuiz && { isQuiz }),
            quizDetails,
            onPageShortAnswerDetails,
            haQuizId: haQuizId || null,
            languageSelectionMenu,
          });
        }
      );
    }

    // sort all the rects in order of startTime
    rectsOut = rectsOut.sort((a, b) => {
      return a.startTime - b.startTime;
    });

    // reassign all the IDs based on the results from the sort
    rectsOut = rectsOut.map((r, i) => {
      return {
        ...r,
        id: i,
      };
    });

    jsonOut = {
      rects: rectsOut,
      points: pointsOut,
      popupTriggers: triggersOut,
    };
    console.log("🚀🚀🚀🚀🚀🚀 triggersOut:", triggersOut);

    // if had quiz has been deleted already no need to update/create a quiz in heres america because its been removed already
    if (isHeresAmericaDomain) {
      if (!hasHaQuizBeenDeleted) {
        await dataToHeresAmericaQuiz(jsonOut, chapterAndPageInfo); // Await to make sure it finishes before proceeding
      }
    }

    const formData = new FormData();
    const fileData = JSON.stringify(jsonOut, null, 2);
    const file = new Blob([fileData], { type: "text/plain" }); //previously was called blob and not file
    //backend
    formData.append("file", file);
    uploadPageJSON(formData);
  };

  async function dataToHeresAmericaQuiz(jsonOut, chapterAndPageInfo) {
    try {
      for (const trigger of jsonOut.popupTriggers) {
        const heresAQuizId = trigger.haQuizId;

        let formattedQuizData = {};

        if (trigger.isQuiz && !trigger.haQuizId) {
          formattedQuizData = {
            ...trigger.quizDetails,
            title: trigger.title,
            haQuizId: heresAQuizId || null,
            titleAudio: trigger.titleAudio,
          };
          const data = await formatQuizDataForHeresAmerica(formattedQuizData);
          const response = await HeresAmericaService.createOrUpdateQuiz(
            bookId,
            { ...data, ...chapterAndPageInfo }
          );

          if (response && response.id) {
            trigger.haQuizId = response.id;
          }
          displaySuccessToast(
            "quiz data to Heres America saved for quiz id: " + response.id
          );
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      displayErrorToast("Error saving quiz data to Heres America");
    }
  }
  function formatQuizDataForHeresAmerica(data) {
    const formattedData = {
      title: data?.title,
      haQuizId: data?.haQuizId,
      attemptsAllowed: data?.attempts,
      isOpenBook: data?.isOpenBook,
      externalBookId: data?.externalBookId,
      quizType: data?.quizType,
      questions: data?.questions.map((question) => ({
        text: question.contents.q,
        type: question.type,
        media: question?.contents?.media,
        feedback: question.contents.feedback,
        attemptsAllowed: question.attemptsAllowed || 1, // Default to 1 if not provided
        answers: question.contents.a.map((answer) => ({
          text: answer?.text,
          media: answer?.media,
          isCorrect: answer?.correct,
        })),
      })),
    };

    return formattedData;
  }

  const handleOnProgress = () => {
    setPlayTime(videoRef.current.getCurrentTime());
  };

  useEffect(() => {
    if (willPause) {
      setIsPlaying(false);
    }
    setWillPause(activeRect.pauseAfter);
  }, [activeRect]);

  //upload json to backend
  // reset ha quiz id to false if it has been deleted
  const uploadPageJSON = (file) => {
    setLoadingUpload(true);
    setHasHaQuizBeenDeleted(false);
    setUploadingModalOpen(true);
    ChapterDataService.uploadPageJSON(pageId, file)
      .then((response) => {
        console.log(
          "🚀 ~ file: DevelopTool.jsx:493 ~ .then ~ response:",
          response
        );
        setLoadingUpload(false);
        displaySuccessToast("Page JSON saved successfully!");
        setCurrentPageJson(response.data);
        // refreshData();
        console.log("Book saved. Response: ", response.data);
        ChapterDataService.uploadBookData(bookId);
      })
      .catch((e) => {
        displayErrorToast("Page JSON failed to save!");
        console.log("error uploading page JSON: ", e);
      });

    // reloadPages();
  };

  const chooseCanvas = (toolName) => {
    const selectCanvas = (
      <SelectCanvas
        background={background}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
        scale={{ x: canvasScale, y: canvasScale }}
        stageRef={stageRef}
        bgRef={bgRef}
        rects={rects}
        setRects={setRects}
        triggers={popupTriggers}
        points={points}
        setPoints={setPoints}
        pointColor={pointColor}
        deselectAll={deselectAll}
        minScale={minScale}
        colorPickerVisible={colorPickerVisible}
        readFill={fill}
        readOpacity={opacity}
        updatePointCoords={updatePointCoords}
        setListening={setListening}
      />
    );

    switch (toolName) {
      case "select":
        return selectCanvas;
      case "draw":
        return (
          <DrawCanvas
            background={background}
            canvasWidth={canvasWidth}
            canvasHeight={canvasHeight}
            scale={{ x: canvasScale, y: canvasScale }}
            stageRef={stageRef}
            bgRef={bgRef}
            rects={rects}
            triggers={popupTriggers}
            pointColor={pointColor}
            setRects={setRects}
            points={points}
            minScale={minScale}
            colorPickerVisible={colorPickerVisible}
            readFill={fill}
            readOpacity={opacity}
          />
        );
      case "textbox":
        return <TextBoxCanvas />;
      case "time assign":
        if (videoRef.current || wavesurferRef.current)
          return (
            <TimeAssignCanvas
              background={background}
              canvasWidth={canvasWidth}
              canvasHeight={canvasHeight}
              scale={{ x: canvasScale, y: canvasScale }}
              stageRef={stageRef}
              bgRef={bgRef}
              rects={rects}
              pointColor={pointColor}
              setRects={setRects}
              triggers={popupTriggers}
              points={points}
              getTime={getTime}
              iterations={iterations}
              setIterations={setIterations}
              workingIteration={workingIteration}
              colorPickerVisible={colorPickerVisible}
              readFill={fill}
              readOpacity={opacity}
              setListening={setListening}
              videoRef={videoRef}
              wavesurferRef={wavesurferRef}
              seekFrame={seekFrame}
              chapterType={chapterType}
              playbackRate={playbackRate}
            />
          );
        break;
      case "coach":
        return (
          <>
            <CoachCanvas
              bookId={bookId}
              background={background}
              stageRef={stageRef}
              canvasHeight={canvasHeight}
              canvasWidth={canvasWidth}
              scale={{ x: canvasScale, y: canvasScale }}
              bgRef={bgRef}
              rects={rects}
              points={points}
              pointColor={pointColor}
              setColor={setPointColor}
              triggers={popupTriggers}
              setPoints={setPoints}
              fill={"#b3b3b350"}
              colorPickerVisible={colorPickerVisible}
              readFill={fill}
              readOpacity={opacity}
              updatePointCoords={updatePointCoords}
              setListening={setListening}
            />
          </>
        );
      case "popup":
        return (
          <PopupCanvas
            handleSaveButton={handleSaveButton}
            bookId={bookId}
            background={background}
            stageRef={stageRef}
            canvasHeight={canvasHeight}
            canvasWidth={canvasWidth}
            scale={{ x: canvasScale, y: canvasScale }}
            bgRef={bgRef}
            rects={rects}
            points={points}
            setHasHaQuizBeenDeleted={setHasHaQuizBeenDeleted}
            popupTriggers={popupTriggers}
            setPopupTriggers={setPopupTriggers}
            pointColor={pointColor}
            setColor={setPointColor}
            setPoints={setPoints}
            updatePointCoords={updatePointCoords}
            updatePopupTriggerCoords={updatePopupTriggerCoords}
            setListening={setListening}
            minScale={minScale}
          />
        );
      default:
        return selectCanvas;
    }
  };
  return (
    <div className="developer">
      <div className="mainContainer" ref={containerRef}>
        {chapterType === "audio" && (
          <div className="audio-container">
            <WsComponent
              wsRef={wavesurferRef}
              source={currentChapter.audioLink}
              bookID={bookId}
              isPlaying={isPlaying}
              setIsPlaying={setIsPlaying}
              currentTime={playTime}
              setCurrentTime={setPlayTime}
              playbackRate={playbackRate}
              setPlaybackRate={setPlaybackRate}
            />
          </div>
        )}
        {chapterType === "video" && (
          <div className={`videoContainer ${preview ? "margin" : ""}`}>
            <ReactPlayer
              ref={videoRef}
              url={videoLink}
              width={canvasWidth}
              height={"auto"}
              controls
              playbackRate={playbackRate}
              playing={isPlaying}
              // how frequently to update progress, in ms
              progressInterval={100}
              onProgress={handleOnProgress}
            />
          </div>
        )}
        {chapterType === "neither" && (
          <div
            style={{
              width: "100%",
              padding: "0.5rem 0px",
              textAlign: "center",
              fontSize: "1.2rem",
              backgroundColor: "#ff000024",
            }}
          >
            No video or audio links! If this is unintended, check the resources
            tab.
          </div>
        )}
        <div className={`controls ${preview ? "hidden" : ""}`}>
          <div className="mainTools">
            <ToolButton
              color={
                currentTool === "select" ? "toolButtonActive" : "toolButton"
              }
              className={currentTool === "select" ? "active" : ""}
              toggle={currentTool}
              icon={<FaMousePointer size={"1.5em"} />}
              onClick={() => {
                setCurrentTool("select");
              }}
              tooltip={"Edit sections (s)"}
              aria-label="select tool"
            />
            <ToolButton
              color={currentTool === "draw" ? "toolButtonActive" : "toolButton"}
              className={currentTool === "draw" ? "active" : ""}
              icon={<BsBoxArrowDownRight size={"1.5em"} />}
              onClick={() => {
                setCurrentTool("draw");
              }}
              tooltip={"Draw new sections (d)"}
              aria-label="create rectangles tool"
            />
            <ToolButton
              color={
                currentTool === "time assign"
                  ? "toolButtonActive"
                  : "toolButton"
              }
              className={currentTool === "time assign" ? "active" : ""}
              icon={<RiMapPinTimeLine size={"1.5em"} />}
              onClick={() => {
                setCurrentTool("time assign");
              }}
              tooltip={"Time assign tool (t)"}
              aria-label="time assign tool"
            />
            <ToolButton
              color={
                currentTool === "coach" ? "toolButtonActive" : "toolButton"
              }
              className={currentTool === "coach" ? "active" : ""}
              icon={<MdLiveHelp size={"1.5em"} />}
              onClick={() => {
                setCurrentTool("coach");
              }}
              tooltip={"Coaching points tool (c)"}
              aria-label="add coaching point tool"
            />
            <ToolButton
              color={
                currentTool === "popup" ? "toolButtonActive" : "toolButton"
              }
              className={currentTool === "popup" ? "active" : ""}
              icon={<MdOutlinePictureInPicture size={"1.5em"} />}
              onClick={() => {
                setCurrentTool("popup");
              }}
              tooltip={"Popup (p)"}
              aria-label="add popup window tool"
            />{" "}
            <ToolButton
              icon={<BsFiletypeJson size={"1.5em"} />}
              onClick={() => {
                setShowJsonEditor((prev) => !prev);
              }}
            />
            <div
              ref={repeatButtonRef}
              className={`repeatToolButton ${
                currentTool === "time assign" ? "visible" : "hidden"
              }`}
              onClick={() => {
                setRepeatPopup(true);
              }}
              aria-label="musical repeat options"
            >
              <RepeatSymbol fill="#e1f0e3" style={{ height: "1.5em" }} />
            </div>
            {repeatButtonRef.current && (
              <RepeatPopup
                open={repeatPopup}
                setOpen={setRepeatPopup}
                iterations={iterations}
                setIterations={setIterations}
                workingIteration={workingIteration}
                setWorkingIteration={setWorkingIteration}
                top={
                  repeatButtonRef.current.getBoundingClientRect().y +
                  window.scrollY
                }
                left={
                  repeatButtonRef.current.getBoundingClientRect().x +
                  repeatButtonRef.current.getBoundingClientRect().width / 2
                }
              />
            )}
            {/* <ToolButton
            className={currentTool === 'textbox' ? 'active' : ''}
            text="Textbox tool"
            onClick={handleTextCreateClick}
            /> */}
          </div>
          <div
            ref={colorButtonRef}
            className="colorButton"
            onClick={(e) => {
              setColorPickerVisible(true);
            }}
            tooltip={"Change the color of the rectangles for the reader"}
            aria-label="Read mode box color"
          >
            <IoColorPaletteOutline
              fill="#e1f0e3"
              stroke="#e1f0e3"
              size={"1.5em"}
            />
          </div>
          <div className={"rightSideButtons"}>
            <IconButton
              color="blueButton"
              className="saveButton"
              icon={canvasWidth <= 550 ? null : <RiSave3Fill size={"1.5em"} />}
              onClick={() => {
                setIsSaveModalOpen(true);
              }}
              text={canvasWidth <= 550 ? <RiSave3Fill size={"2em"} /> : "Save"}
              tooltip={
                "Save changes (" + (OS === "mac" ? "⌘" : "Ctrl") + " + s)"
              }
            />
            <IconButton
              color="redButton"
              className={"clearCanvas"}
              icon={canvasWidth <= 550 ? null : <MdDelete size={"1.5em"} />}
              onClick={() => {
                setIsClearModalOpen(true);
              }}
              text={canvasWidth <= 550 ? <MdDelete size={"2em"} /> : "Clear"}
              tooltip="Clear canvas"
            />
          </div>
        </div>
        {/* <UploadQuizImage bookId={bookId} /> */}
        <div
          className={`canvasContainer ${
            chapterType === "neither" ? "nomedia" : ""
          }`}
        >
          {!preview && chooseCanvas(currentTool)}
          {preview && (
            <ReadCanvas
              background={background}
              canvasWidth={canvasWidth}
              canvasHeight={canvasHeight}
              scale={{ x: canvasScale, y: canvasScale }}
              stageRef={stageRef}
              bgRef={bgRef}
              rects={rects}
              setRects={setRects}
              points={points}
              pointColor={pointColor}
              fill={fill}
              opacity={opacity}
              seek={seek}
              currentTime={playTime}
              setActiveRect={setActiveRect}
              willPause={willPause}
              duration={
                videoRef.current?.getDuration() ||
                wavesurferRef.current?.getDuration() ||
                0
              }
              handleKeyDown={handleKeyDown}
              pageId={pageId}
            />
          )}{" "}
        </div>

        {!preview && colorButtonRef.current && (
          <ColorPopup
            open={colorPickerVisible}
            setOpen={setColorPickerVisible}
            anchor={colorButtonRef.current}
            pickerColor={pickerColor}
            changePickerColor={changePickerColor}
          />
        )}

        <CustomYesNoModal
          title={"Are you sure you want to clear this page?"}
          isOpen={isClearModalOpen}
          onClose={() => {
            setIsClearModalOpen(false);
          }}
          onSubmit={clearCanvas}
          initial={""}
        />
        <CustomYesNoModal
          title={"Save your changes to this page?"}
          isOpen={isSaveModalOpen}
          onClose={() => {
            setIsSaveModalOpen(false);
          }}
          onSubmit={() => {
            handleSaveButton();
            setIsSaveModalOpen(false);
          }}
          initial={""}
        />
      </div>
      {showJsonEditor && (
        <JsonObjectEditor
          rects={rects}
          popupTriggers={popupTriggers}
          points={points}
          setRects={setRects}
          setPoints={setPoints}
          setPopupTriggers={setPopupTriggers}
        />
      )}
    </div>
  );
}

export default DevelopTool;

function JsonObjectEditor({
  rects,
  points,
  popupTriggers,
  setRects,
  setPoints,
  setPopupTriggers,
}) {
  // States to hold the JSON input for each part
  const [rectsInput, setRectsInput] = useState(JSON.stringify(rects, null, 2));
  const [pointsInput, setPointsInput] = useState(
    JSON.stringify(points, null, 2)
  );
  const [popupTriggersInput, setPopupTriggersInput] = useState(
    JSON.stringify(popupTriggers, null, 2)
  );

  useEffect(() => {
    setRectsInput(JSON.stringify(rects, null, 2));
  }, [rects]);

  useEffect(() => {
    setPointsInput(JSON.stringify(points, null, 2));
  }, [points]);

  useEffect(() => {
    setPopupTriggersInput(JSON.stringify(popupTriggers, null, 2));
  }, [popupTriggers]);

  // Handlers for button clicks to update state
  const updateRects = () => {
    try {
      setRects(JSON.parse(rectsInput));
    } catch (error) {
      console.error("Error parsing rects JSON: ", error);
    }
  };

  const updatePoints = () => {
    try {
      setPoints(JSON.parse(pointsInput));
    } catch (error) {
      console.error("Error parsing points JSON: ", error);
    }
  };

  const updatePopupTriggers = () => {
    try {
      setPopupTriggers(JSON.parse(popupTriggersInput));
    } catch (error) {
      console.error("Error parsing popupTriggers JSON: ", error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <h2>Rects</h2>
        <textarea
          rows="10"
          cols="50"
          value={rectsInput}
          onChange={(e) => setRectsInput(e.target.value)}
          style={{ fontFamily: "monospace" }}
        />
        <button onClick={updateRects}>Update Rects</button>
      </div>
      <div>
        <h2>Points</h2>
        <textarea
          rows="10"
          cols="50"
          value={pointsInput}
          onChange={(e) => setPointsInput(e.target.value)}
          style={{ fontFamily: "monospace" }}
        />
        <button onClick={updatePoints}>Update Points</button>
      </div>
      <div>
        <h2>Popup Triggers</h2>
        <textarea
          rows="10"
          cols="50"
          value={popupTriggersInput}
          onChange={(e) => setPopupTriggersInput(e.target.value)}
          style={{ fontFamily: "monospace" }}
        />
        <button onClick={updatePopupTriggers}>Update Popup Triggers</button>
      </div>
    </div>
  );
}
